module.exports = __webpack_public_path__ + "img/qr_tool.0e508ffb.jpg";